import { useState } from "react";
import "./DoctorsGridPageCss/DoctorGridFirstSection.css";
import {
  FaSearch,
  FaStethoscope,
  FaUser,
  FaMapMarkerAlt,
} from "react-icons/fa";
import DoctorImageSection from "./DoctorImageSection";
import Select from "react-select";
import useIsMobile from "../../Hooks/IsmobileHook";
import { Autocomplete, TextField } from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";

const departmentOptions = [
  { value: "", label: "Select Department" },
  {
    value: "Advanced Laparoscopic Surgeon",
    label: "Advanced Laparoscopic Surgeon",
  },
  { value: "Ayurvedacharya", label: "Ayurvedacharya" },
  { value: "Cardiologist", label: "Cardiologist" },
  {
    value: "Chest Physician/ Pulmonologist",
    label: "Chest Physician/ Pulmonologist",
  },
  { value: "Dentist", label: "Dentist" },
  { value: "Dermatologist", label: "Dermatologist" },
  { value: "Diabetologist", label: "Diabetologist" },
  { value: "Endocrinologist", label: "Endocrinologist" },
  { value: "Dietician/Nutritionist", label: "Dietician/Nutritionist" },
  { value: "Echo-Cardiologist", label: "Echo-Cardiologist" },
  { value: "Ent Specialist", label: "Ent Specialist" },
  { value: "Eye Specialist", label: "Eye Specialist" },
  { value: "Gastroenterologist", label: "Gastroenterologist" },
  {
    value: "General & Laparoscopic Surgeon",
    label: "General & Laparoscopic Surgeon",
  },
  { value: "General Medicine", label: "General Medicine" },
  { value: "General Physician", label: "General Physician" },
  { value: "Gynecologist", label: "Gynecologist" },
  { value: "Gynecology and Obstetrics", label: "Gynecology and Obstetrics" },
  { value: "Hepatologist", label: "Hepatologist" },
  { value: "Homeopath", label: "Homeopath" },
  { value: "Infertility", label: "Infertility" },
  {
    value: "Interventional Cardiologist",
    label: "Interventional Cardiologist",
  },
  {
    value: "Liver Transplant & HBP Surgeon",
    label: "Liver Transplant & HBP Surgeon",
  },
  { value: "Nephrologist", label: "Nephrologist" },
  { value: "Neurologist", label: "Neurologist" },
  { value: "Neurosurgeon", label: "Neurosurgeon" },
  { value: "Oncologist", label: "Oncologist" },
  {
    value: "Oral & Maxillofacial Surgeon",
    label: "Oral & Maxillofacial Surgeon",
  },
  { value: "Orthopaedic", label: "Orthopaedic" },
  { value: "Orthopaedic Surgeon", label: "Orthopaedic Surgeon" },
  { value: "Paediatrician", label: "Paediatrician" },
  { value: "Pathologist", label: "Pathologist" },
  { value: "Peadiatric Cardiology", label: "Peadiatric Cardiology" },
  { value: "Physiotherapist", label: "Physiotherapist" },
  { value: "Plastic Surgery", label: "Plastic Surgery" },
  { value: "Psychiatrist", label: "Psychiatrist" },
  { value: "Psychologist", label: "Psychologist" },
  { value: "Radiologist", label: "Radiologist" },
  {
    value: "Rehabilitation Med & Pain Management",
    label: "Rehabilitation Med & Pain Management",
  },
  {
    value: "Renal Transplant & Urologist",
    label: "Renal Transplant & Urologist",
  },
  { value: "Rheumatologist", label: "Rheumatologist" },
  { value: "Sonologist", label: "Sonologist" },
  { value: "Spine Surgeon", label: "Spine Surgeon" },
  { value: "Thoracic Surgeon", label: "Thoracic Surgeon" },
  { value: "Urologist", label: "Urologist" },
  { value: "Vascular Surgeon", label: "Vascular Surgeon" },
];

const branchOptions = [
  { value: "", label: "Select Branch" },
  { value: "Salt Lake", label: "Salt Lake" },
  { value: "Behala", label: "Behala" },
  { value: "Andul", label: "Andul" },
  { value: "Kankurgachi", label: "Kankurgachi" },
  { value: "Topsia", label: "Topsia" },
  { value: "Tobin Road", label: "Tobin Road" },
  { value: "Barasat", label: "Barasat" },
  { value: "Deshpriya Park", label: "Deshpriya Park" },
  { value: "Laketown", label: "Laketown" },
];

export default function DoctorsGridFirstSection({
  onSearch,
  locations,
  selectedCenter,
  setSelectedCenter,
  specializationData,
  setSpecializationData,
}) {
  const isMobile = useIsMobile();
  const [doctorName, setDoctorName] = useState("");
  const [department, setDepartment] = useState();
  const [branch, setBranch] = useState("");

  const handleSearch = () => {
    onSearch({
      doctorName,
      department: department?.specialization_id,
      branch,
    });
  };

  return (
    <div className="gridContainer">
      <div className="gridUpperTextSection">
        <DoctorImageSection />

        <div className="customSearchBar">
          {/* Doctor Name Input */}
          <div className="inputWithIcon">
            <FaUser className="inputIcon" />
            <input
              type="text"
              placeholder="Search Doctor by name"
              value={doctorName}
              onChange={(e) => {
                const value = e.target.value;
                setDoctorName(value);
                onSearch({
                  doctorName: value,
                  department: department?.specialization_id ?? "",
                  branch,
                });
              }}
              aria-label="Search doctor by name"
            />
            {doctorName && (
              <span
                className="clearIcon"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setDoctorName("");
                  onSearch({
                    doctorName: "",
                    department: department?.specialization_id ?? "",
                    branch,
                  });
                }}
              >
                ✖
              </span>
            )}
          </div>

          {/* {!isMobile && (
            <>
              <div className="divider" />

              
              <div className="inputWithIcon">
                <FaStethoscope className="inputIcon" />
                <select
                  value={department?.specialization_id || ""}
                  onChange={(e) => {
                    const selectedValue = e.target.value;

                    const selectedOption = specializationData.find(
                      (opt) => opt.specialization_id == selectedValue
                    );

                    if (selectedOption) {
                      setDepartment(selectedOption);
                      onSearch({
                        doctorName,
                        department: selectedOption.specialization_id,
                        branch,
                      });
                    }
                  }}
                  className="basicDropdown"
                >
                  <option value="">Select Specialization</option>
                  {specializationData.map((option) => (
                    <option
                      key={option.specialization_id}
                      value={option.specialization_id}
                    >
                      {option.specialization}
                    </option>
                  ))}
                </select>
              </div>

              <div className="divider" />

              
              <div className="inputWithIcon">
                <FaMapMarkerAlt className="inputIcon" />
                <select
                  value={branch}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                   
                    setBranch(selectedValue);
                    onSearch({
                      doctorName,
                      department: department?.specialization_id,
                      branch: selectedValue,
                    });
                  }}
                  className="basicDropdown"
                >
                  <option value="">Select Center</option>
                  {locations.map((location) => (
                    <option key={location.center_id} value={location.center_id}>
                      {location.center_name}
                    </option>
                  ))}
                </select>
              </div>
            </>
          )} */}
          {/* <div className="opdDoctorSearchActions">
            <button className="styledSearchBtn rbdButton opdResetButton" onClick={() => {
              setDoctorName("");
              setDepartment(null);
              setBranch("");

              onSearch({
                doctorName: "",
                department: "",
                branch: "",
              });
            }}>
              <span className="btn-text" style={{
                display:"flex",
                alignItems:"center",
                gap:"3px"
              }}>
                <AiOutlineClose size={18}/> <span>Reset</span>
              </span>
            </button>


             <button className="styledSearchBtn rbdButton" onClick={handleSearch}>
              <span className="btn-text">
                <FaSearch /> <span>Search</span>
              </span>
            </button>
          </div> */}

        </div>
      </div>
    </div>
  );
}
